import axios from "axios"
import wx from "weixin-js-sdk";
import $ from "@/../static/js/jquery.min.js"
export default {
    // getWxShare(data) {
    //     var dat = '';
    //     for (var key in data) {
    //         dat += encodeURIComponent(key) + '=' + encodeURIComponent(data[key]) + '&'
    //     }
    //     this.getWXConf(dat);
    // },

    // getWXConf: function (data) {
    //     var that = this
    //     axios.post('http://apim.lzep.cn/v1/share/getWxConfig', data, {
    //         headers: {
    //             'Content-type': 'application/x-www-form-urlencoded'
    //         }
    //     }).then(res => {
    //         that.weiXinCon(res.data);
    //     })
    // },
    getWxShare: function (data) {
        // return
        var _this = this
        // console.log('分享传递vm',vm)
        $.ajax({
            type: 'POST',
            data: data,
            url: 'http://apim.lzep.cn/v1/share/getWxConfig',
            success: function (data) {
                // console.log(this,_this)
                _this.weiXinCon(JSON.parse(data));
            },
            error: function () {
                // console.log('error');
            }
        })
    },

    weiXinCon: function (data) {
        var dat = vm.$store.state.shareData;
        wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: data.appId, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.nonceStr, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名
            jsApiList: ["onMenuShareAppMessage"] // 必填，需要使用的JS接口列表
        });
        wx.ready(function () {
            wx.onMenuShareAppMessage({
                // 获取“转发”按钮点击状态及自定义分享内容接口
                title: dat.title || data.title, // 分享标题
                desc: dat.description || data.description, // 分享描述
                link: dat.url || data.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: dat.thumb || data.thumb, // 分享图标
                success: function () {
                    // 设置成功
                    // console.log(_this)
                    // _this.doShare(vm)
                },
                cancel: function () {
                    // 用户取消分享后执行的回调函数
                }
            });
            wx.onMenuShareTimeline({
                // 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口
                title: data.title, // 分享标题
                link: data.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: data.thumb, // 分享图标
                success: function () {
                    // 设置成功
                    // console.log(_this)
                    // _this.doShare(vm)
                },
                cancel: function () {
                    // 用户取消分享后执行的回调函数
                }
            });
            wx.error(function (res) {
                // config信息验证失败会执行error函数，如签名过期导致验证失败
                console.log('config信息验证失败会执行error函数，如签名过期导致验证失败')
            });
            
        });
    },
}


// WEBPACK FOOTER //
// ./src/assets/js/wxshare.js